import type { BimModelDto, ModelVersionDto } from "../../../../types/bim-viewer.types";

export const mockModel: BimModelDto = {
  modelId: 9001,
  projectId: 42,
  modelName: "Tower A — Architectural",
  modelDescription: "Mock model for viewer UI development (Track 0)",
  discipline: "ARCHITECTURAL",
  ifcSchema: "IFC4",
  fileName: "tower-a-arch-v3.ifc",
  fileSize: 184_500_000,
  fileUrl: "mock://tower-a-arch-v3.ifc",
  downloadUrl: "mock://tower-a-arch-v3.ifc",
  status: "active",
  parseStatus: "parsed",
  currentVersion: 3,
  totalElements: 15240,
  totalStoreys: 12,
  createdAt: "2026-03-12T09:14:00Z",
  updatedAt: "2026-05-21T16:42:00Z",
  createdBy: 7,
  updatedBy: 7,
  createdByUserName: "Priya Menon",
  updatedByUserName: "Priya Menon",
};

export const mockProjectModels: BimModelDto[] = [
  mockModel,
  {
    ...mockModel,
    modelId: 9002,
    modelName: "Tower A — Structural",
    discipline: "STRUCTURAL",
    fileName: "tower-a-struct-v2.ifc",
    fileSize: 96_300_000,
    currentVersion: 2,
    totalElements: 8420,
    createdByUserName: "Arjun Iyer",
    updatedByUserName: "Arjun Iyer",
  },
  {
    ...mockModel,
    modelId: 9003,
    modelName: "Tower A — MEP",
    discipline: "MEP_MECHANICAL",
    fileName: "tower-a-mep-v4.ifc",
    fileSize: 212_700_000,
    currentVersion: 4,
    totalElements: 19880,
    createdByUserName: "Layla Hassan",
    updatedByUserName: "Layla Hassan",
  },
];

export const mockVersions: ModelVersionDto[] = [
  {
    versionId: 30001,
    modelId: 9001,
    versionNumber: 3,
    fileName: "tower-a-arch-v3.ifc",
    fileSize: 184_500_000,
    fileUrl: "mock://tower-a-arch-v3.ifc",
    versionComment: "Coordinated with structural rev 2; updated curtain wall mullion spacing.",
    parseStatus: "parsed",
    totalElements: 15240,
    uploadedAt: "2026-05-21T16:42:00Z",
    uploadedBy: 7,
    uploadedByUserName: "Priya Menon",
    parentVersionId: 30000,
    elementCount: 15240,
  },
  {
    versionId: 30000,
    modelId: 9001,
    versionNumber: 2,
    fileName: "tower-a-arch-v2.ifc",
    fileSize: 178_100_000,
    fileUrl: "mock://tower-a-arch-v2.ifc",
    versionComment: "Resolved 8 critical clashes against structural.",
    parseStatus: "parsed",
    totalElements: 14980,
    uploadedAt: "2026-04-08T11:20:00Z",
    uploadedBy: 7,
    uploadedByUserName: "Priya Menon",
    parentVersionId: 29999,
    elementCount: 14980,
  },
  {
    versionId: 29999,
    modelId: 9001,
    versionNumber: 1,
    fileName: "tower-a-arch-v1.ifc",
    fileSize: 162_400_000,
    fileUrl: "mock://tower-a-arch-v1.ifc",
    versionComment: "Initial issue for design review.",
    parseStatus: "parsed",
    totalElements: 14110,
    uploadedAt: "2026-03-12T09:14:00Z",
    uploadedBy: 7,
    uploadedByUserName: "Priya Menon",
    elementCount: 14110,
  },
];
